<div class="modal-header">
    <h4 class="modal-title">Actualizar Orden de Trabajo N° {{element.id}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
        <li [ngbNavItem]="1">
            <a ngbNavLink>Detalles</a>
            <ng-template ngbNavContent>
                <form [formGroup]="form">
                    <div class="d-flex gap-2">
                        <div class="form-group col-12 col-sm">
                            <label for="tipo">Concepto</label>
                            <div class="form-group">
                                <select class="form-select" id="tipo" formControlName="tipo_revision_id" (change)="fecha_estimada()"
                                    [ngClass]="{'is-invalid': form.controls['tipo_revision_id'].errors && form.controls['tipo_revision_id'].touched}">
                                    <ng-container *ngFor="let tipo of tipos">
                                        <option [value]="tipo.id">{{tipo.nombre}}</option>
                                    </ng-container>
                                </select>
                                <div class="invalid-feedback">
                                    Debe ingresar un valor en el campo
                                </div>
                            </div>
                        </div>
                        <div class=" d-none d-sm-block mt-4">
                            <button class="btn btn-primary w-100" (click)="agregarConcepto()"><i class="fas fa-plus"></i></button>
                        </div>
                    
                        <div class="form-group col-12 col-sm">
                            <label for="fecha">Fecha</label>
                            <input type="date" (change)="fecha_estimada()" (keyup)="fecha_estimada()" class="form-control" id="fecha"
                                formControlName="fecha"
                                [ngClass]="{'is-invalid': form.controls['fecha'].errors && form.controls['fecha'].touched}">
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo
                            </div>
                            <div class="mb-4" *ngIf="!form.controls['fecha'].errors || !form.controls['fecha'].touched">
                            </div>
                        </div>
                    </div>
                    
                    <div class="d-flex gap-2 mb-3">
                        <div class="form-group col-12 col-sm">
                            <label for="vehiculo_id">Vehículo</label>
                            <ng-select [items]="vehiculos" formControlName="vehiculo_id" bindValue="id" labelForId="vehiculo_id"
                                (change)="fecha_estimada()" [searchFn]="searchFn" [virtualScroll]="true"
                                [readonly]="form.controls['vehiculo_id'].disabled" bindLabel="patente"
                                [ngClass]="{'is-invalid': form.controls['vehiculo_id'].errors && form.controls['vehiculo_id'].touched}"
                                appendTo="body">
                                <ng-template ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                                    {{item.patente}} - {{item.usuario ? item.usuario.nombre : 'Sin'}} {{item.usuario ?
                                    item.usuario.apellido : 'Dueño'}}
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                    {{item.patente}} - {{item.usuario ? item.usuario.nombre : 'Sin'}} {{item.usuario ?
                                    item.usuario.apellido : 'Dueño'}}
                                </ng-template>
                            </ng-select>
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo
                            </div>
                        </div>
                        <div class=" d-none d-sm-block mt-4" (click)="agregarVehiculo()">
                            <button class="btn btn-primary w-100"><i class="fas fa-plus"></i></button>
                        </div>
                    </div>

                    <div class="d-flex gap-2">
                        <div class="form-group w-100">
                            <label for="encargado_id">Encargado</label>
                            <ng-select [items]="encargados" formControlName="encargado_id" bindValue="id" labelForId="encargado_id"
                                [searchFn]="searchFnEncargado" [virtualScroll]="true" [readonly]="form.controls['encargado_id'].disabled"
                                [ngClass]="{'is-invalid': form.controls['encargado_id'].errors && form.controls['encargado_id'].touched}"
                                appendTo="body">
                                <ng-template ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                                    {{formatter.nombreCompleto(item)}}
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                    {{formatter.nombreCompleto(item)}}
                                </ng-template>
                            </ng-select>
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo
                            </div>
                            <div class="mb-4" *ngIf="!form.controls['encargado_id'].errors || !form.controls['encargado_id'].touched">
                            </div>
                        </div>
                        <div class="d-none d-sm-block mt-4" (click)="agregarEncargado()">
                            <button class="btn btn-primary w-100"><i class="fas fa-plus"></i></button>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="form-group col-12 col-sm-6">
                            <label for="kilometraje">Kilometraje</label>
                            <input type="text" class="form-control" id="kilometraje" formControlName="kilometraje"
                                (keyup)="fecha_estimada()" (change)="fecha_estimada()" thousandSeparator="." mask="separator.0"
                                [allowNegativeNumbers]="false"
                                [ngClass]="{'is-invalid': form.controls['kilometraje'].errors && form.controls['kilometraje'].touched}">
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo
                            </div>
                            <div class="mb-4" *ngIf="!form.controls['kilometraje'].errors || !form.controls['kilometraje'].touched">
                            </div>
                        </div>
                        <div class="form-group col-12 col-sm-6">
                            <label for="proxima_revision">Kilometraje para próxima revisión</label>
                            <input type="text" class="form-control" id="proxima_revision" formControlName="proxima_revision"
                                (keyup)="fecha_estimada()" (change)="fecha_estimada()" thousandSeparator="." mask="separator.0"
                                [allowNegativeNumbers]="false"
                                [ngClass]="{'is-invalid': form.controls['proxima_revision'].errors && form.controls['proxima_revision'].touched}">
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo
                            </div>
                            <div class="mb-4"
                                *ngIf="!form.controls['proxima_revision'].errors || !form.controls['proxima_revision'].touched">
                            </div>
                        </div>
                        <div class="form-group col-12 col-sm-12">
                            <label for="fecha_estimada">Estimado Siguiente Revisión</label><label class="campo-opcional"> (Opcional)</label>
                            <input type="date" class="form-control" id="fecha_estimada" formControlName="fecha_estimada"
                                [ngClass]="{'is-invalid': form.controls['fecha_estimada'].errors && form.controls['fecha_estimada'].touched}">
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo
                            </div>
                            <div class="mb-4" *ngIf="!form.controls['fecha_estimada'].errors || !form.controls['fecha_estimada'].touched">
                            </div>
                        </div>
                    
                        <div class="form-group">
                            <label for="detalle">Detalles</label><label class="campo-opcional"> (Opcional)</label>
                            <textarea class="form-control" id="detalle" rows="6" formControlName="detalle"></textarea>
                        </div>
                    
                    </div>
                </form>
            </ng-template>
        </li>
        <li [ngbNavItem]="2">
            <a ngbNavLink>Productos y Servicios</a>
            <ng-template ngbNavContent>
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Producto/Servicio</th>
                            <th scope="col">Cantidad</th>
                            <th scope="col">Valor Unitario</th>
                            <th scope="col">SubTotal</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of lineas; let index = index">
                            <td style="vertical-align: middle;" class="w-100">
                                <ng-select [ngClass]="{'border rounded border-danger': !item.producto_id}" [items]="productos"
                                    bindValue="id" labelForId="producto" [searchFn]="searchFnProducto" [virtualScroll]="true"
                                    bindLabel="nombre" [(ngModel)]="item.producto_id" groupBy="tipo"
                                    (change)="productoCambiado($event, index)">
                                    <ng-template ng-label-tmp let-item="item">
                                        {{item.nombre}}
                                    </ng-template>
                                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                        <div class="d-flex justify-content-between px-3">
                                            <div class="d-flex flex-column">
                                                <div *ngIf="item.codigo_barra || item.sku" class="d-flex gap-2"
                                                    style="font-size: small; color: gray;">
                                                    <div>
                                                        <i class="fas fa-barcode"></i>
                                                    </div>
                                                    <div *ngIf="item.codigo_barra">{{item.codigo_barra}}</div>
                                                    <div>-</div>
                                                    <div *ngIf="item.sku">SKU {{item.sku}}</div>
                                                </div>
                                                <div>{{item.nombre}}</div>
                                            </div>
                                            <div *ngIf="item.precio_venta">$ {{formatter.numberFormat(item.precio_venta)}}</div>
                                        </div>
                
                                    </ng-template>
                                </ng-select>
                            </td>
                            <td style="min-width: 100px;vertical-align: middle;"><input type="text" class="form-control"
                                    [(ngModel)]="item.cantidad" thousandSeparator="." mask="separator.0"
                                    (change)="cantidadCambiada(item)"></td>
                            <td style="min-width: 150px;vertical-align: middle;"><input type="text" class="form-control"
                                    [(ngModel)]="item.precio_unitario" thousandSeparator="." mask="separator.0"
                                    (change)="valorCambiado(item)"></td>
                            <td class="text-right" style="min-width: 130px;vertical-align: middle;">$
                                {{formatter.numberFormat(item.precio_unitario * item.cantidad)}}</td>
                            <td><button class="btn btn-light text-danger" (click)="quitarProducto(index)"><i
                                        class="fas fa-trash"></i></button></td>
                        </tr>
                        <tr>
                            <td colspan="5">
                                <button class="btn btn-primary w-100" (click)="agregarProducto()"><i class="fas fa-plus"></i></button>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="3">Total</th>
                            <th class="text-right">$ {{formatter.numberFormat(total)}}</th>
                            <th></th>
                        </tr>
                    </tfoot>
                </table>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="border border-top-0 p-3"></div>
</div>
<div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="guardar()">Actualizar</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel click')">Cerrar</button>
</div>